module.exports = __webpack_public_path__ + "static/media/UpdatesSocial.95e93ee6.jpg";